const thumbsEl = document.querySelector('.js-maintenance-thumbs');
const swiperEl = document.querySelector('.js-maintenance-slider');

if (thumbsEl && swiperEl) initDiagnosticCostTabs();

function initDiagnosticCostTabs() {
    const selectedThumbs = thumbsEl.getElementsByClassName('_selected');
    const selectedSlides = swiperEl.getElementsByClassName('_selected');

    const thumbs =  new Swiper(thumbsEl, {
        slidesPerView: "auto",
        freeMode: true,
        mousewheel: true,
        grabCursor: true,
        spaceBetween: 17,
        watchSlidesProgress: true,
        on: {
            click: (swiper, {target}) => {
                const slide = target.closest('.swiper-slide');
                const [selected] = selectedThumbs;

                if (!slide || slide === selected) return;

                selected.classList.remove('_selected');
                slide.classList.add('_selected');
                swiper.slideTo(swiper.clickedIndex, 300);
            }
        },
        breakpoints: {
            767: {
                spaceBetween: 27,
            }
        }
    });

    new Swiper(swiperEl, {
        effect: 'fade',
        allowTouchMove: false,
        fadeEffect: {
            crossFade: true,
        },
        thumbs: {
            swiper: thumbs,
        }
    });
}
